import { stagePostForm } from "@/shared/api";

/** Максимальная цена выкупа для одного из грейдов */
export interface GradePriceInfo {
    /** Код грейда, например "Q" */
    grade: string;
    gradeName: string;
    gradeDesc: string;
    /** Нормализованный код грейда (A, B, C, D, E, F) */
    gradeNormalized: string;
    price: number;
    currency: string;
    /** Сумма дополнительной скидки */
    additionalDiscountValue: number;
    /** Сумма мгновенной скидки */
    instantAmount: number;
}

export type SigningType = "TRUSTME_KZ" | "WITHOUT_SMS" | "SCRIVE" | "OTHER";

/** Сдаваемое устройство, зарегистрированное в it4 для оценки */
export interface RegisteredDevice {
    deviceId: string;
    gradeId: string;
    gradeName: string;
    /** Текущая оценка состояния, например "Q" */
    grade: string;
    gradeNormalized: string;
    gradeDescription: string;
    /** Базовая цена выкупа, например "121000.00". Не число - устройство не принимается */
    price: string;
    currency: string;
    additionalDiscountValue: number;
    instantAmount: number;
    preliminaryPriceGradeInfo: {
        gradePriceInfo: GradePriceInfo[];
    };
    /** Превью сдаваемого устройства */
    tradeinThumbnail: string;
    tradeinArticle: string;
    /** Есть фотооценка */
    canPhotosetGrading: boolean;
    /** Можно оценить состояние в виджете. Иначе устройство оценивают в магазине */
    canWidgetGrading: boolean;
    /** Варианты подписания договора */
    signingTypes: SigningType[];
}

/**
 * Зарегистрировать сдаваемое устройство
 * 5.1 документация ru 1.0.5
 */
export function apiRegisterDevice(payload: {
    /** Выбранная модификация сдаваемого устройства */
    productId: string;
    token: string;
    lang: string;
    /** Артикул покупаемого устройства со страницы партнёра */
    article: string;
}): Promise<RegisteredDevice> {
    return stagePostForm<RegisteredDevice>("/api/tin/v1/site/quest/device", payload);
}
